<script setup>
    import { ref, defineAsyncComponent, computed } from 'vue'
    import { Icon } from '@iconify/vue'
    import { useRouter } from 'vue-router'
    import { useChannelsStore } from '@/stores/channels'
    import { useTemplateStore } from '@/stores/templates'

    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice.vue'
    import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal.vue'
    import { executeLogin, initLogin, loadSDK } from '@/composables/useFacebookLogin'
    import {notify} from '@kyvg/vue3-notification';

    const SelectFormValidate = defineAsyncComponent(() => import('@/components/UI/Form/SelectFormValidate.vue'))
    const TabUserDepartment = defineAsyncComponent(() => import('@/components/tabs/TabUserDepartment.vue'))
    const ChatTransition = defineAsyncComponent(() => import('@/components/utils/ChatTransition.vue'))
    const Toggle = defineAsyncComponent(() => import('@/components/UI/Toogle/ToogleWithDescription.vue'))

    const store = useChannelsStore()
    const router = useRouter()
    const templateStore = useTemplateStore()

    const authorizationAttendance = ref('')
    const pixOrder = ref('')
    const coexistence = ref('')

    store.formStep = 2
    templateStore.fetchItems()
    store.channel.type = store.channel.type || 'whatsapp'
    store.channel.server_type = store.channel.server_type || 'otima'

    // Inicializar o objeto more se não existir
    if (!store.channel.more) {
        store.channel.more = {}
    }

    if(store.channel?.more?.pix_order) {
        pixOrder.value = store.channel.more.pix_order
    }

    if (store.channel?.more?.coexistence) {
        coexistence.value = store.channel.more.coexistence
    }

    const optionMessagesTemplate = computed(() => {
        if(templateStore.all.length > 0) {
            return templateStore.all.filter((item) => item.channel === store.channel?.id)
            .map(
                (item) => ({
                    value: item.id,
                    title: item.name,
                    message: item.message
                })
            )
        }
        return [{ value: '', title: 'Nenhuma mensagem template', message: '' }]
    })
    
    /**
     * WHATS META - Código do Facebook mantido para compatibilidade
     */
    loadSDK(document, 'script', 'facebook-jssdk')

    const appId = 1002416697451596
    initLogin(appId)

    const registerMetaUrl = `${window.origin}/v2/canais/cadastrar/whatsapp/whatsapp-meta`
    const registerMetaParams = new URLSearchParams()

    const loginMeta = response => {
      if (
          !response?.authResponse?.code ||
          !registerMetaParams.has('phone_number_id') ||
          !registerMetaParams.has('waba_id')
      ) {
        console.error(
            'Code',
            response?.authResponse?.code,
            'Register Params',
            registerMetaParams
        )
        notify({
          type: 'error',
          title: 'Opps...',
          text: 'Não foi possível realizar o login. Por favor, tente realizar o login no Facebook novamente!',
        })
        return
      }

      setTimeout(() => router.push({ name: 'channels.home' }), 1000)

      notify({
          type: 'success',
          title: 'Tudo certo...',
          text: 'Você será redirecionado para finalizar o cadastro do WhatsApp Meta!',
        })

      registerMetaParams.set('api_token', response.authResponse.code)

      const popup = window.open(
          `${registerMetaUrl}?${registerMetaParams.toString()}`,
          'integratedApiMeta',
          'toolbar=no, menubar=no, width=600, height=900, top=100, left=100'
      )

      if (!popup || popup.closed || typeof popup.closed == 'undefined') {
        notify({
          type: 'error',
          title: 'Atenção',
          text: 'O popup foi bloqueado pelo navegador. Por favor, permita popups para este site e tente novamente.'
        })
        return
      }
    }

    window.addEventListener('message', (event) => {
      if (
          event.origin !== "https://www.facebook.com" &&
          event.origin !== "https://web.facebook.com"
      ) {
        const data = JSON.parse(event.data);
        console.log('ORIGIN NÃO É FACEBOOK', event.origin, data)
        return;
      }

      try {
        const data = JSON.parse(event.data);
        console.log('DATA MESSAGE', data)
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (
            data.event === 'FINISH' ||
            data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING'
          ) {
            const { phone_number_id, waba_id } = data.data;

            registerMetaParams.set('phone_number_id', phone_number_id)
            registerMetaParams.set('waba_id', waba_id)
            registerMetaParams.set('business_id', data.business_id)
          } else if (data.event === 'CANCEL') {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);

            notify({
              type: 'error',
              title: 'Opps...',
              text: 'O processo foi cancelado pelo usuário!',
            })
          } else if (data.event === 'ERROR') {
            const { error_message } = data.data;
            console.error("error ", error_message);

            notify({
              type: 'error',
              title: 'Opps...',
              text: 'Não foi possível realizar o login: ' + error_message,
            })
          }
        }
      } catch {
        console.log('Non JSON Responses', event.data);
      }
    });

    function handleToggleAuthorization(value) {
        authorizationAttendance.value = value
        store.channel.start_service = null
    }

    function handleSelectPixOrder(value) {
        store.channel.more.pix_order = value
    }

    function handleToggleCoexistence(value) {
        store.channel.more.coexistence = value
    }
    
</script>

<template>
    <div class="space-y-4 w-full">
        <InputFormHorizontal
            v-model="store.channel.name"
            :init-value="store.channel.name"
            :block-edit="store.loading"
            label="Nome do canal"
            placeholder="Como você irá identificar o canal pelo sistema?"
            rules="required"
            vertical
        />
        <InputFormHorizontal
            v-model="store.channel.user"
            :init-value="store.channel.user"
            :block-edit="!!store.channel?.id"
            label="Número do WhatsApp"
            hint="Ao cadastrar o canal, o número é vinculado automaticamente. Não é possível alterá-lo!"
            vertical
        />
        <InputFormHorizontal
            v-model="store.channel.api_token"
            :init-value="store.channel.api_token"
            :block-edit="store.loading"
            label="API TOKEN"
            placeholder="Insira o token da API do WhatsApp Otima"
            rules="required"
            vertical
        />
        
        <InputFormHorizontal
            v-model="store.channel.more.broker_code"
            :init-value="store.channel.more?.broker_code || ''"
            label="Broker Code"
            hint="Código do corretor fornecido pela Otima"
            vertical
        />
        <InputFormHorizontal
            v-model="store.channel.more.customer_code"
            :init-value="store.channel.more?.customer_code || ''"
            label="Customer Code"
            hint="Código do cliente fornecido pela Otima"
            vertical
        />
        <InputFormHorizontal
            v-model="store.channel.more.endpoint"
            :init-value="store.channel.more?.endpoint || ''"
            label="EndPoint"
            hint="Informe o endpoint"
            vertical
        />
    </div>
</template>